// extracted by mini-css-extract-plugin
export default {"fileNameWrapper":"AttachFilesItem_fileNameWrapper__hUP7i","fileName":"AttachFilesItem_fileName__lkLXC","disabled":"AttachFilesItem_disabled__4W3aW"};